import { DynamicAttribute } from '../models/attribute_meta';

export const DOCUMENT_FILE_ACCEPT = '.pdf,.txt,.csv,.xls,.doc,.xlsx,.docx';
export const FILE_URL_TYPES = ['picture', 'video', 'signature', 'file'];

export function deserializeFactAttribute(attr: DynamicAttribute, data: Record<string, any>): void {
  const rawValue = data[attr.getMesName()];
  const fileUrlKey = `mes_file_url_${attr.id}`;
  const fileUrl = data[fileUrlKey];

  if (fileUrl && FILE_URL_TYPES.includes(attr.type)) {
    if (rawValue && typeof rawValue === 'object') {
      // Pictures keep their public URL inline in the value; only fall back to the
      // separate mes_file_url_<id> field for legacy values that don't carry one.
      attr.deserialize({ ...rawValue, url: rawValue.url || fileUrl });
    } else if (rawValue && typeof rawValue === 'string') {
      attr.deserialize({ name: rawValue, url: fileUrl });
    } else {
      attr.deserialize({ name: '', url: fileUrl });
    }
  } else {
    attr.deserialize(rawValue);
  }
}

export function scrollToFirstEmptyChild(element: HTMLElement | Element) {
  for (var i = 0; i < element.children.length; i++) {
    let child = element.children[i] as HTMLElement;
    if (child.children[0].classList.contains('overview-empty-value')) {
      child.click();
      child.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      break;
    }
  }
}
